//@flow
import * as React from 'react';
import {baseClass} from "../../../../pages/UiKit/newUiKit/utilities/baseClass";
import type {children, id} from "../../../../services/flowTypes/appFlowTypes";
import type {addClasses} from "../../../../services/flowTypes/uiKitFlowTypes";
import './FixedHeader.css';

type Props = {
  id?: id,
  addClasses?: addClasses,
  children: children
};

const FixedHeader = (props: Props) => {
  return (
    <div id={props.id} className={baseClass("FixedHeader", props.addClasses)}>{props.children}</div>
  );
};

export default FixedHeader;